module.exports = __webpack_public_path__ + "static/media/secure-package@2x.3777b9ee.png";